// ----------------------------------------------------------------------------
// Section: Banner Block
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Script
import 'snippets/background-media/background-media';

// Styles
import './_banner-block.scss';